import { Type, type Static } from '@sinclair/typebox';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { EmailSchema } from './email.schema';

export const GetEmailsListResponseSchema = ListResponseSchema(EmailSchema);

export const GetEmailResponseSchema = EmailSchema;

export const GetThreadResponseSchema = Type.Object({
  object: Type.Literal('Thread'),
  id: Type.String({ description: 'The ID of the thread.' }),
  emails: Type.Array(EmailSchema),
});

export const TrashEmailResponseSchema = Type.Object({
  object: Type.Literal('EmailTrashed'),
});

export const ModifyEmailResponseSchema = EmailSchema;

export const ReadEmailResponseSchema = Type.Object({
  object: Type.Literal('EmailRead'),
});

export const UnreadEmailResponseSchema = Type.Object({
  object: Type.Literal('EmailUnread'),
});

export const SendEmailResponseSchema = Type.Object({
  object: Type.Literal('EmailSent'),
  id: Type.String({ description: 'The ID of the email.' }),
  message_id: Type.Optional(
    Type.String({
      description:
        'The Message-ID header value of the email. Use `id` in Unipile requests. May be absent when the header could not be retrieved after sending (the email has been sent anyway).',
    }),
  ),
});

export type GetEmailsListResponse = Static<typeof GetEmailsListResponseSchema>;
export type GetEmailResponse = Static<typeof GetEmailResponseSchema>;
export type GetThreadResponse = Static<typeof GetThreadResponseSchema>;
export type TrashEmailResponse = Static<typeof TrashEmailResponseSchema>;
export type ModifyEmailResponse = Static<typeof ModifyEmailResponseSchema>;
export type ReadEmailResponse = Static<typeof ReadEmailResponseSchema>;
export type UnreadEmailResponse = Static<typeof UnreadEmailResponseSchema>;
export type SendEmailResponse = Static<typeof SendEmailResponseSchema>;
